import React, { forwardRef, HTMLAttributes } from 'react';
import { joinClassNames } from '../../utils';
import styles from './Fullscreen.module.scss';

type FullscreenRootProps = HTMLAttributes<HTMLDivElement>;

export const FullscreenRoot = forwardRef<HTMLDivElement, FullscreenRootProps>(
  ({ children, className, ...props }, ref) => {
    const classNames = joinClassNames(styles.root, className);
    return (
      <div className={classNames} {...props} ref={ref}>
        {children}
      </div>
    );
  }
);
